async function initLoyaltyCardSection(loyaltySection, shouldRenderForm) {
  const { customerId, cardNumber, status } = cardInformation;
  if (!customerId) {
    show(SELECTORS.loyaltyDescription, loyaltySection);
    return;
  }

  if (cardNumber) {
    if (status == "ok" || status === null) {
      showAll(SELECTORS.loyaltyDetails, loyaltySection);
      updateCustomerCurrentPoints();
      handleNewPointsUpdate();
      if (shouldRenderForm) {
        await initCoupons();
      }
    } else if (status === "blocked") {
      showAll(SELECTORS.cardBlockedSection);
    } else if (status === "deleted") {
      show(SELECTORS.cardDeletedMessage, loyaltySection)
      await initializePhoneVerification();
    }
  } else if (shouldRenderForm) {
    await initializePhoneVerification();
  } else {
    show(SELECTORS.loyaltyNoCard, loyaltySection);
  }
}

function updateCustomerCurrentPoints() {
  const cardPointsElements = document.querySelectorAll(SELECTORS.cardPoints);
  if (!cardPointsElements) return;
  const currentPoints = cardInformation.balancePoints || 0;
  cardPointsElements.forEach(element => {
    element.innerHTML = window.loyaltyProgram.points + currentPoints;
  });
  showAll(SELECTORS.cardPoints);
}

async function initCoupons() {
  if (!cardInformation.cardNumber) return;
  const couponData = await getCouponData(cardInformation.cardNumber);
  if (couponData && couponData.discounts > 0) {
    generateCouponButtons(couponData, cardInformation.cardNumber);
  }
}

function generateCouponButtons(couponData, cardNumber) {
  const couponContainer = document.querySelector(SELECTORS.couponsContainer);
  
  if (!couponContainer) {
    return;
  }
  
  couponContainer.innerHTML = "";
  const fragment = document.createDocumentFragment();
  const maxCouponValue = couponData.discounts * couponData.singleDiscountValueEuro;
  const fixedAmounts = [5, 10, 15, 20, 25, 30, 50];
  fixedAmounts.forEach(value => {
    if (value > maxCouponValue) return;

    const button = document.createElement("button");
    button.classList.add("btn", "btn--medium", "btn--full", "btn--secondary");
    const valueContainer = document.createElement("div");
    valueContainer.classList.add("coupon-info");
    valueContainer.innerHTML = `${value} ${window.loyaltyProgram.currency}`;
    button.appendChild(valueContainer);

    const activations = Math.floor(maxCouponValue / value);
    button.disabled = activations === 0;

    if (!button.disabled) {
      button.addEventListener("click", async () => {
        await handleCouponGeneration(cardNumber, value);
      });
    } else {
      button.classList.add("disabled");
    }

    const activationInfo = document.createElement("span");
    activationInfo.classList.add("activation-info");
    let message = activations === 1 ? window.loyaltyProgram.singleCoupon : window.loyaltyProgram.multipleCoupons;
    activationInfo.innerHTML = ` (${activations} ${message})`;
    button.appendChild(activationInfo);

    fragment.appendChild(button);
    show(SELECTORS.couponsWrapper);

  });

  const lastFixedAmount = fixedAmounts[fixedAmounts.length - 1];
  const roundedMaxCouponValue = Math.floor(maxCouponValue / 5) * 5;

  if (roundedMaxCouponValue > lastFixedAmount) {
    const totalCouponButton = document.createElement("button");
    totalCouponButton.classList.add("btn", "btn--medium", "btn--full", "btn--secondary");
    totalCouponButton.innerHTML = `${maxCouponValue} ${window.loyaltyProgram.currency}`;
    totalCouponButton.disabled = maxCouponValue === 0;

    if (!totalCouponButton.disabled) {
      totalCouponButton.addEventListener("click", async () => {
        await handleCouponGeneration(cardNumber, maxCouponValue);
      });
    } else {
      totalCouponButton.classList.add("disabled");
    }

    const totalActivationInfo = document.createElement("span");
    totalActivationInfo.classList.add("activation-info");
    totalActivationInfo.innerHTML = ` (1 ${window.loyaltyProgram.singleCoupon})`;
    totalCouponButton.appendChild(totalActivationInfo);

    fragment.appendChild(totalCouponButton);
  }

  couponContainer.appendChild(fragment);
}

async function handleCouponGeneration(cardNumber, value) {
  const { modalOverlay, cancelButton, confirmationButton } = generateActivationElement(value);
  modalOverlay.style.display = "flex";

  cancelButton.addEventListener("click", () => {
    modalOverlay.style.display = "none";
    document.body.classList.remove("no-scroll");
  });

  confirmationButton.addEventListener("click", async e => {
    modalOverlay.style.display = "none"; // Close the modal
    hide(SELECTORS.confirmationMessage);
    const result = await generateCoupon(cardNumber, value, window.loyaltyProgram.customerId);

    if (!result || !result.coupon) {
      const couponContainer = document.querySelector(SELECTORS.couponsContainer);
      showError(couponContainer, MESSAGES.couponError);
      return;
    }
    cardInformation.balancePoints = result.pointsNow;
    const coupon = result.coupon;
    showCouponActivatedModal(coupon, value);
    await initCoupons();
    updateCustomerCurrentPoints();
    const couponData = await getCouponData(cardInformation.cardNumber);
    const maxCouponValue = couponData?.discounts * couponData?.singleDiscountValueEuro;
    updateCustomerNewPointsAndCouponValue(0, maxCouponValue);
  });
}

function generateActivationElement(value) {
  removeActivationElement();
  const confirmationMessage = window.loyaltyProgram.confirmationMessage
    .replace("{{couponValue}}", value)
    .replace("{{currency}}", window.loyaltyProgram.currency);

  const { closeButton, modalOverlay, confirmationButton, cancelButton } = generateModal("modal-content", `${confirmationMessage}`, window.loyaltyProgram.confirmationButton, window.loyaltyProgram.cancelButton);

  closeButton.addEventListener("click", () => {
    modalOverlay.style.display = "none";
    document.body.classList.remove("no-scroll");
  });

  confirmationButton.addEventListener("click", async () => {
    modalOverlay.style.display = "none";
    document.body.classList.remove("no-scroll");
  });

  modalOverlay.addEventListener("click", (event) => {
    if (event.target === modalOverlay) {
      modalOverlay.style.display = "none";
      document.body.classList.remove("no-scroll");
    }
  });

  return { modalOverlay, cancelButton, confirmationButton };
}

function removeActivationElement() {
  const existingConfirmationElement = document.querySelector(SELECTORS.confirmationMessage);
  if (existingConfirmationElement) {
    existingConfirmationElement.remove();
  }
}

function showCouponActivatedModal(coupon, value) {
  const couponSuccessMessage = window.loyaltyProgram.couponSuccessMessage
    .replace("{{couponValue}}", value)
    .replace("{{currency}}", window.loyaltyProgram.currency);

  const couponSuccessElement = document.querySelector(SELECTORS.couponSuccessMessage);
  couponSuccessElement.innerHTML = couponSuccessMessage;

  const {closeButton, modalOverlay, confirmationButton} = generateModal("modal-content", `${couponSuccessMessage}<strong>${coupon}</strong>`, window.loyaltyProgram.successButton);

  closeButton.addEventListener("click", () => {
    modalOverlay.style.display = "none";
    document.body.classList.remove("no-scroll");
  });

  modalOverlay.addEventListener("click", (event) => {
    if (event.target === modalOverlay) {
      modalOverlay.style.display = "none";
      document.body.classList.remove("no-scroll");
    }
  });

  confirmationButton.addEventListener("click", async () => {
    modalOverlay.style.display = "none";
    document.body.classList.remove("no-scroll");
  });
}

function updateCustomerNewPointsAndCouponValue(points, maxCouponValue) {
  if (points > 0) {
    const cartDrawerElement = document.querySelector(SELECTORS.cartDrawer);
    const cartElement = document.querySelector(SELECTORS.cart);

    const cardNewPointsDrawerElement = cartDrawerElement?.querySelector(SELECTORS.newPoints);
    let cardNewPointsElements = [cardNewPointsDrawerElement];
    let cardNewPointsCartElement = null;

    if (cartElement) {
      cardNewPointsCartElement = cartElement?.querySelector(SELECTORS.newPoints);
      cardNewPointsElements.push(cardNewPointsCartElement);
    }

    cardNewPointsElements.filter(element => element != null);

    if (cardNewPointsElements.length == 0) return;
    cardNewPointsElements.forEach(element => {
      const text = window.loyaltyProgram.newPoints.replace("{{points}}", points);
      element.innerHTML = text;
    });
  }
  
  if (maxCouponValue > 0) {
    const couponsInformationElements = document.querySelectorAll(SELECTORS.couponsInformation);
    if (couponsInformationElements.length > 0) {
      couponsInformationElements.forEach(couponsInformationElement => {
        const text = window.loyaltyProgram.currentMaxCoupon.replace("{{MaxCouponValue}}", maxCouponValue).replace("{{currency}}", window.loyaltyProgram.currency);
        couponsInformationElement.innerHTML = text;
      });
    }
  }
}

async function initializePhoneVerification() {
  show(SELECTORS.formPhone);
  const formSubmit = document.querySelector(SELECTORS.formPhone);
  if (!formSubmit) return;
  formSubmit.addEventListener("submit", async e => {
    e.preventDefault();
    const phoneNumber = document.querySelector(SELECTORS.phoneNumber).value;
    const countryCode = document.querySelector(SELECTORS.countryCode).value;
    const fullPhoneNumber = getFullPhoneNumber(countryCode, phoneNumber);

    if (!isValidFullPhoneNumber(fullPhoneNumber)) {
      const errorElement = document.querySelector(SELECTORS.phoneError);
      showError(errorElement, MESSAGES.invalidPhoneNumber);
      return;
    }

    hideError(document.querySelector(SELECTORS.phoneError));
    const response = await verifyPhoneNumber(fullPhoneNumber);
    if(!response || response.answerCode != 0) {
      show(SELECTORS.phoneVerificationError)
      return
    }
    showInsertOTPForm(fullPhoneNumber);
  });
}

function showInsertOTPForm(fullPhoneNumber) {
  const otpForm = document.querySelector(SELECTORS.formOtp);
  if (!otpForm) return;

  hide(SELECTORS.formPhone);
  show(SELECTORS.formOtp);

  const countdownElement = document.querySelector(SELECTORS.countdown);
  if (countdownElement) {
    startCountdown(60, countdownElement);
  }

  async function handleOtpSubmit(e) {
    e.preventDefault();
    const otp = document.querySelector(SELECTORS.otpNumber).value.trim();
    const errorElement = document.querySelector(SELECTORS.otpError);

    // Validate OTP
    if (!isValidOTP(otp)) {
      showError(errorElement, MESSAGES.invalidOTPLength);
      return;
    }

    hideError(errorElement);

    try {
      const result = await verifyOTP(fullPhoneNumber, otp, email);
      console.log("🚀 ~ handleOtpSubmit ~ result:", result)

      // Handle OTP verification failure
      if (!result || result.answerCode !== 0) {
        if (result?.answerCode === 315) {
          showError(errorElement, MESSAGES.invalidOTP);
        } else {
          showError(errorElement, MESSAGES.genericError);
          handleOtpFailure();
        }
        return;
      }

      // OTP verification success
      const customersData = await getCustomerData(fullPhoneNumber);
      await handleCardVerificationResult(customersData);
    } catch (error) {
      console.error("Error verifying OTP:", error);
      showError(errorElement, MESSAGES.genericError);
      handleOtpFailure();
    }
  }

  function handleOtpFailure() {
    console.log(`otp failed`);
    hide(SELECTORS.submitOtpButton);
    hide(SELECTORS.countdown);
    hide(SELECTORS.resendOtp);
    hide(SELECTORS.resendOtpText);
    hide(SELECTORS.resendOtpButton);
    show(SELECTORS.restartVerificationButton);

    const restartVerificationButton = document.querySelector(SELECTORS.restartVerificationButton);
    restartVerificationButton.addEventListener(
      "click",
      () => {
        hide(SELECTORS.formOtp);
        resetOtpForm();
        show(SELECTORS.formPhone);
      },
      { once: true }
    );
  }
  otpForm.addEventListener("submit", handleOtpSubmit);
}

function startCountdown(duration, element) {
  let timer = duration;
  const interval = setInterval(() => {
    const minutes = String(Math.floor(timer / 60)).padStart(2, "0");
    const seconds = String(timer % 60).padStart(2, "0");

    element.innerHTML = `${minutes}:${seconds}`;
    if (--timer < 0) {
      clearInterval(interval);
      hide(SELECTORS.resendOtpText);
      hide(SELECTORS.countdown);
      show(SELECTORS.resendOtpButton);

      const resendButton = document.querySelector(SELECTORS.resendOtpButton);
      const handleResendClick = async e => {
        e.preventDefault();
        hide(SELECTORS.resendButton);
        const countdownElement = document.querySelector(SELECTORS.countdown);
        if (countdownElement) {
          countdownElement.innerHTML = "";
        }
        const fullPhoneNumber = getFullPhoneNumber();
        const response = await verifyPhoneNumber(fullPhoneNumber);
        if (!response || response.answerCode != 0) {
          show(SELECTORS.otpError);
        }
        show(SELECTORS.resendOtpText);
        hide(SELECTORS.resendOtpButton);
        hide(SELECTORS.otpError);
        show(SELECTORS.countdown);
        startCountdown(60, element);
        resendButton.removeEventListener("click", handleResendClick);
      };

      resendButton.addEventListener("click", handleResendClick);
      enableSubmitButton(resendButton);
    }
  }, 1000);
}

function resetOtpForm() {
  hide(SELECTORS.resendOtpText);
  hide(SELECTORS.resendOtpButton);
  hide(SELECTORS.formOtp);
  hide(SELECTORS.restartVerificationButton);
  show(SELECTORS.submitOtpButton);
  hideError(document.querySelector(SELECTORS.otpError));
  const otpForm = document.querySelector(SELECTORS.formOtp);
  otpForm.removeEventListener("submit", handleCardVerificationResult);
  const inputElement = document.querySelector(SELECTORS.otpNumber);
  inputElement.value = "";
}

async function handleCardVerificationResult(customers) {
  const sectionElement = document.querySelector(SELECTORS.loyaltySection);
  if (customers?.length > 0) {
    const balancePoints = customers[0].balanceData.balance_points;
    const cardNumber = customers[0].card;
    const keyXUserId = customers[0].id;

    cardInformation.balancePoints = balancePoints;
    cardInformation.cardNumber = cardNumber;
    const customerCardNumber = cardNumber;

    const cardNumberElements = document.querySelectorAll(SELECTORS.cardNumber);
    cardNumberElements.forEach((cardNumberElement) => {
      cardNumberElement.innerHTML = window.loyaltyProgram.cardNumberMessage + customerCardNumber;
    });
    updateCustomerCurrentPoints();
    const metafieldUpdated = await updateCardMetafield(cardNumber, keyXUserId);
    if (!metafieldUpdated || metafieldUpdated.message != "Card saved successfully") {
      showUpdateMetafieldError();
    }
    handleNewPointsUpdate();
    hideAll(SELECTORS.formOtp); 
    hideAll(SELECTORS.formPhone);
    hideAll(SELECTORS.loyaltyNoCard);
    showAll(SELECTORS.loyaltyDetails);
    showModal("modal-content", `${window.loyaltyProgram.accountExistsMessage}`, window.loyaltyProgram.successButton);
  } else {
    hide(SELECTORS.formOtp, sectionElement);
    show(SELECTORS.formNewCard, sectionElement);
    initializeRegistrationForm();
  }
}

function generateModal(className, message, confirmationButtonText, cancelButtonText) {
  const existingModal = document.querySelector(".modal-overlay");
  if (existingModal) existingModal.remove();

  const modalContent = document.createElement("div");
  modalContent.classList.add(className);

  const messageDiv = document.createElement("div");
  messageDiv.innerHTML = message;
  messageDiv.classList.add("modal-message");
  modalContent.appendChild(messageDiv);

  const closeButton = document.createElement("button");
  closeButton.classList.add("modal-close");
  closeButton.innerHTML = "&times;";
  modalContent.appendChild(closeButton);

  const confirmationButton = document.createElement("button");
  confirmationButton.classList.add("btn", "btn--medium", "btn--full", "btn--secondary");
  confirmationButton.innerHTML = confirmationButtonText;

  const buttonsContainer = document.createElement("div");
  buttonsContainer.classList.add("confirmation-buttons");
  buttonsContainer.appendChild(confirmationButton);
  modalContent.appendChild(buttonsContainer);

  let cancelButton = null;
  if(cancelButtonText) {
    cancelButton = document.createElement("button");
    cancelButton.classList.add("btn", "btn--medium", "btn--full", "btn--secondary");
    cancelButton.innerHTML = cancelButtonText;
    buttonsContainer.appendChild(cancelButton);
  }

  const modalOverlay = document.createElement("div");
  modalOverlay.classList.add("modal-overlay");
  modalOverlay.appendChild(modalContent);

  document.body.appendChild(modalOverlay);
  document.body.classList.add("no-scroll");
  modalOverlay.style.display = "flex";

  if(cancelButton) {
    return {closeButton, modalOverlay, confirmationButton, cancelButton} 
  } else {
    return {closeButton, modalOverlay, confirmationButton}
  }
}

function showModal(className, message, confirmationButtonText) {
  const {closeButton, modalOverlay, confirmationButton} = generateModal(className, message, confirmationButtonText);

  closeButton.addEventListener("click", async () => {
    await handleConfirmationButtonClick();
  });

  modalOverlay.addEventListener("click", async (event) => {
    if (event.target === modalOverlay) {
      await handleConfirmationButtonClick();
    }
  });

  confirmationButton.addEventListener("click", async () => {
    await handleConfirmationButtonClick();
  });

  async function handleConfirmationButtonClick() {
    modalOverlay.style.display = "none";
    document.body.classList.remove("no-scroll");
    await initCoupons();
  }
}

function initializeRegistrationForm() {
  const registrationForm = document.querySelector(SELECTORS.formNewCard);
  if (!registrationForm) return;
  const phoneNumber = document.querySelector(SELECTORS.phoneNumber)?.value;
  const countryCode = document.querySelector(SELECTORS.countryCode)?.value;
  registrationForm.querySelector(SELECTORS.phone).value = phoneNumber || "";
  registrationForm.querySelector(SELECTORS.phoneHidden).value = phoneNumber || "";
  registrationForm.querySelector(SELECTORS.countryCode).value = countryCode || "";
  registrationForm.querySelector(SELECTORS.email).value = "";

  const formFields = getFormFields();

  registrationForm.addEventListener("submit", async e => {
    e.preventDefault();

    const formFieldsValues = getFormFieldsValues();
    const isFormValid = validateFormFields(formFieldsValues);
    if (isFormValid) {
      enableSubmitButton(registrationForm.querySelector(".btn"));
      const newCardData = await createNewCard(formFieldsValues);
      if (!newCardData) {
        show(SELECTORS.registrationError);
        return;
      }
      cardInformation.cardNumber = newCardData?.customer?.card;
      cardInformation.balancePoints = newCardData?.customer?.balanceData?.balance_points;
      const cardNumberElements = document.querySelectorAll(SELECTORS.cardNumber);
      cardNumberElements.forEach((cardNumberElement) => {
        cardNumberElement.innerHTML = window.loyaltyProgram.cardNumberMessage + newCardData?.customer?.card;
      });
      const card = newCardData?.customer?.card;
      const keyXUserId = newCardData?.customer?.id;
      const metafieldUpdated = await updateCardMetafield(card, keyXUserId);
      if (!metafieldUpdated || metafieldUpdated.message != "Card saved successfully") {
        showUpdateMetafieldError();
      }
      // show current card number
      // show modal with success message, upon closing the modal execute all other instruction
      showModal("modal-content", `${window.loyaltyProgram.cardCreatedMessage}`, window.loyaltyProgram.successButton);
      updateCustomerCurrentPoints();
      handleNewPointsUpdate();
      hide(SELECTORS.formNewCard);
      hideAll(SELECTORS.loyaltyNoCard);
      show(SELECTORS.cardCreatedMessage);
      showAll(SELECTORS.loyaltyDetails);
    } else {
      disableSubmitButton(registrationForm.querySelector(".btn"));
    }
  });

  Object.values(formFields).forEach(formElement => {
    formElement?.addEventListener("blur", e => {
      const formFieldsValues = getFormFieldsValues();
      const isFormValid = validateFormFields(formFieldsValues);
      if (isFormValid) {
        enableSubmitButton(registrationForm.querySelector(".btn"));
      } else {
        disableSubmitButton(registrationForm.querySelector(".btn"));
      }
    });
  });

  formFields.termsAndConditions?.addEventListener("change", e => {
    const formFieldsValues = getFormFieldsValues();
    const isFormValid = validateFormFields(formFieldsValues);
    if (isFormValid) {
      enableSubmitButton(registrationForm.querySelector(".btn"));
    } else {
      disableSubmitButton(registrationForm.querySelector(".btn"));
    }
  });
}

function showUpdateMetafieldError() {
  const loyaltySection = document.querySelector(SELECTORS.loyaltySection);
  const errorElement = document.createElement("div");
  errorElement.classList.add("error");
  errorElement.innerHTML = MESSAGES.updateMetafieldError;
  loyaltySection.appendChild(errorElement);
}

function getFormFields() {
  const formFields = {
    email: document.querySelector(SELECTORS.email),
    firstName: document.querySelector(SELECTORS.firstName),
    lastName: document.querySelector(SELECTORS.lastName),
    date: document.querySelector(SELECTORS.date),
    countryCode: document.querySelector(SELECTORS.countryCode),
    phoneNumber: document.querySelector(SELECTORS.phoneHidden),
    gender: document.querySelector(SELECTORS.gender),
    promotions: document.querySelector(SELECTORS.usedForPromotions),
    statistics: document.querySelector(SELECTORS.usedForStatistics),
    termsAndConditions: document.querySelector(SELECTORS.termsAndConditions)
  };
  return formFields;
}

function getFormFieldsValues() {
  const formFields = getFormFields();
  const formFieldsValues = {
    email: formFields.email?.value.trim(),
    firstName: formFields.firstName?.value.trim(),
    lastName: formFields.lastName?.value.trim(),
    date: formFields.date?.value.trim(),
    countryCode: formFields.countryCode?.value.trim(),
    phoneNumber: formFields.phoneNumber?.value.trim(),
    gender: formFields.gender.value,
    usedforpromotions: formFields.promotions?.checked || false,
    usedforstatistics: formFields.statistics?.checked || false,
    isTermsAndConditionsChecked: formFields.termsAndConditions?.checked
  };
  return formFieldsValues;
}

function validateFormFields(formFieldsValues) {
  const { email, firstName, lastName, date, phoneNumber, isTermsAndConditionsChecked } = formFieldsValues;
  const isEmailValid = !email || validateInput(email, isValidEmail, SELECTORS.email, MESSAGES.invalidEmail);
  const isFirstNameValid = validateInput(firstName, isValidString, SELECTORS.firstName, MESSAGES.invalidFirstName);
  const isLastNameValid = validateInput(lastName, isValidString, SELECTORS.lastName, MESSAGES.invalidLastName);
  const isDateValid = validateInput(date, isValidDate, SELECTORS.date, MESSAGES.invalidDate);
  const isPhoneNumberValid = validateInput(phoneNumber, isValidPhoneNumber, SELECTORS.phone, MESSAGES.invalidPhone);

  const errorElement = document.querySelector(SELECTORS.termsAndConditionsError);
  if (!isTermsAndConditionsChecked) {
    showError(errorElement, MESSAGES.termsAndConditionsError);
  } else {
    hideError(errorElement);
  }
  if (isEmailValid && isFirstNameValid && isLastNameValid && isDateValid && isPhoneNumberValid && isTermsAndConditionsChecked) {
    return true;
  } else {
    return false;
  }
}

async function initLoyaltyDrawer(cartDrawerElement) {
  const { customerId, cardNumber, status } = cardInformation;
  show(SELECTORS.loyaltyContent, cartDrawerElement);

  if (!customerId && !cardNumber) {
    show(SELECTORS.loyaltyDescription, cartDrawerElement);
    return;
  }

  if (customerId && !cardNumber) {
    show(SELECTORS.loyaltyNoCard, cartDrawerElement);
    return;
  }

  if (customerId && cardNumber && (status == "ok" || status === null)) {
    updateCustomerCurrentPoints();
    handleNewPointsUpdate();
    showAll(SELECTORS.loyaltyDetails, cartDrawerElement);
    return;
  }
}

async function handleNewPointsUpdate() {
  const cart = await fetchCart();
  const cartTotalValue = cart.total_price  ? cart.total_price / 100 : 0;
  const newPoints = await getNewOrderPoints(cartTotalValue);
  const couponData = await getCouponData(cardInformation.cardNumber);
  const cartDrawerElement = document.querySelector(SELECTORS.cartDrawer);
  const cartElement = document.querySelector(SELECTORS.cart);
  const loyaltySection = document.querySelector(SELECTORS.loyaltySection);
  const maxCouponValue = couponData?.discounts * couponData?.singleDiscountValueEuro;

  if (newPoints > 0 || maxCouponValue > 0) {
    updateCustomerNewPointsAndCouponValue(newPoints, maxCouponValue);
    if (cartDrawerElement) {
      showAll(SELECTORS.newPoints, cartDrawerElement);
    }
    if (cartElement) {
      showAll(SELECTORS.newPoints, loyaltySection);
    }
  } else {
    if (cartDrawerElement) {
      hideAll(SELECTORS.newPoints, cartDrawerElement);
    }
    if (cartElement) {
      hideAll(SELECTORS.newPoints, loyaltySection);
    }
  }
}

const cardInformation = {};

async function initCardInfo() {
  cardInformation.customerId = window.loyaltyProgram.customerId || null;
  cardInformation.cardNumber = window.loyaltyProgram.cardNumber || null;
  cardInformation.endpoint = window.loyaltyProgram.endpoint;
  cardInformation.keyXCustomerId = window.loyaltyProgram.keyXCustomerId || null;
  cardInformation.status = null;
  if (cardInformation.cardNumber && cardInformation.keyXCustomerId) {
    const customerResult = await getCustomerInfo();
    if (customerResult?.answerCode == 90) {
      cardInformation.status = "deleted";
    } else if (customerResult?.answerCode == 0) {
      const status = customerResult.customer.balanceData?.status;
      if (status == 2) {
        cardInformation.status = "blocked";
      } else if (status == 1) {
        cardInformation.status = "ok";
        const result = await retrieveCardNumberInformation(cardInformation.cardNumber);
        const balancePoints = result?.customer?.balanceData?.balance_points || null;
        cardInformation.balancePoints = balancePoints;
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", async function () {
  console.log(`loaded ======================`);
  const loyaltySection = document.querySelector(SELECTORS.loyaltySection);
  const shouldRenderForm = window.loyaltyProgram.shouldRenderForm;
  const cartDrawerElement = document.querySelector(SELECTORS.cartDrawer);
  const shouldRenderInDrawer = true;

  if (!loyaltySection && !(cartDrawerElement && shouldRenderInDrawer)) return;

  await initCardInfo();
  attachListeners(loyaltySection);

  if (loyaltySection) {
    show(SELECTORS.complementaryImage, loyaltySection);
    await initLoyaltyCardSection(loyaltySection, shouldRenderForm);
  }

  if (cartDrawerElement && shouldRenderInDrawer) {
    await initLoyaltyDrawer(cartDrawerElement);
  }
});

function attachListeners(loyaltySection) {
  if (loyaltySection) {
    loyaltySection.querySelector("#phoneNumber").addEventListener("blur", e => {
      e.preventDefault();
      const isValid = validateInput(e.target.value, isValidPhoneNumber, SELECTORS.phoneNumber, MESSAGES.invalidPhoneNumber);
      const button = loyaltySection.querySelector("#formPhone .btn");

      if (isValid) {
        enableSubmitButton(button);
        hide(SELECTORS.phoneError);
      } else {
        disableSubmitButton(button);
        show(SELECTORS.phoneError);
      }
    });

    loyaltySection.querySelector("#phoneNumber").addEventListener("input", e => {
      e.preventDefault();
      if (e.target.value.length >= 10) {
        const isValid = validateInput(e.target.value, isValidPhoneNumber, SELECTORS.phoneNumber, MESSAGES.invalidPhoneNumber);
        const button = loyaltySection.querySelector("#formPhone .btn");
        button.removeAttribute("disabled");
        button.classList.remove("disabled");

        isValid ? enableSubmitButton(button) : disableSubmitButton(button);
      }
    });

    loyaltySection.querySelector("#otpNumber").addEventListener("input", e => {
      e.preventDefault();
      if (e.target.value.length == 6) {
        const button = loyaltySection.querySelector("#formOtp .btn");
        enableSubmitButton(button);
      }
    });
  }
  document.addEventListener("cart:update-loyalty-points", async () => {
    handleNewPointsUpdate();
  });
}
